/**
 * Règles badges tutoriel (aligné spec Prysma) :
 * - fv = fully_viewed_at (dernier parcours complet API + état tutoriel)
 * - ann = update_announced_at (signal admin)
 * Comparaison ann > fv sur chaînes ISO (ordre lexicographique = temporel pour ISO 8601 UTC).
 */

function normalizeIso(value) {
  if (value == null) return '';
  return String(value).trim();
}

/**
 * @returns {'new'|'updated'|null}
 */
export function getTutorialHelpBadge(tutorial) {
  if (!tutorial) return null;
  const fv = normalizeIso(tutorial.fully_viewed_at);
  const ann = normalizeIso(tutorial.update_announced_at);
  if (!fv) return 'new';
  if (ann && ann > fv) return 'updated';
  return null;
}

export function effectiveHelpStatusFromTutorial(tutorial) {
  if (!tutorial) return 'nouveau';
  const b = getTutorialHelpBadge(tutorial);
  if (b === 'new') return 'nouveau';
  if (b === 'updated') return 'mis_a_jour';
  return 'a_jour';
}

/**
 * Priorité thème agrégé (mis à jour → nouveau) — pour usages hors ligne accordéon.
 */
export function aggregateThemeHelpStatus(tutorials) {
  if (!Array.isArray(tutorials) || tutorials.length === 0) return null;
  let hasMis = false;
  let hasNouveau = false;
  for (const t of tutorials) {
    const b = getTutorialHelpBadge(t);
    if (b === 'updated') hasMis = true;
    else if (b === 'new') hasNouveau = true;
  }
  if (hasMis) return 'mis_a_jour';
  if (hasNouveau) return 'nouveau';
  return null;
}
